<script>

import ContractSubmit from './Submit.vue';
import moment from 'moment';
import {axios} from '../../mixins';

moment().format();

export default {

  name: 'ContractsIndex',

  mixins: [axios],

  components: {ContractSubmit},

  props: {
    contractsList: {
      required: true,
      type: Array,
      default: function () {
        return [];
      },
    },
  },

  data() {
    return {
      contracts: [],
    };
  },

  computed: {},

  created() {
    this.contracts = this.contractsList
  },

  methods: {
    updateContracts() {
      this.get('/contracts').then((response) => {
        this.contracts = response.data
      }).catch(() => {
      });
    },

    status: function (value) {
      let status = ''
      if (value === 1 || value === 2) {
        status = 'Submitted'
      } else if (value === 3) {
        status = 'Reviewed'
      } else if (value === 4) {
        status = 'Signed'
      } else if (value === 5) {
        status = 'Completed'
      }

      return status
    }
  },
};

</script>

<template>

  <div class="flex w-full">
    <div class="flex flex-col bg-grey-dark w-1/2 rounded-md ml-2 mr-2">
      <div class="p-6 flex flex-col justify-center text-center text-white">
        <div class="text-xl font-semibold p-3 text-left">
          Contracts ({{ contracts.length }})
        </div>

        <a v-for="contract in contracts"
           :href="`/contracts/` + contract.id"
           class="w-full bg-grey hover:bg-grey-light rounded-sm p-4 mb-3" font-semibold>
          {{ contract.year }} : {{ status(contract.status) }}
        </a>

      </div>
    </div>

    <div class="flex flex-col bg-grey-dark w-1/2 rounded-md ml-2 p-6 text-white">
      <div class="text-xl font-semibold p-3 text-left">
        Application Submission
      </div>
      <slot></slot>
<!--      Disabled should be set by if there's a contract this year. UPDATE to check for contract this year -->
      <ContractSubmit @submitted="updateContracts"
      :disabled="contracts.length > 0"></ContractSubmit>

    </div>
  </div>

</template>
